export default "__VITE_ASSET__8628efad__"